"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
const industries = [{
  id: 1,
  title: "Ավիատիեզերական Ընկերություններ և Անվտանգություն",
  subtitle: "",
  description: "Հեռազննումը հնարավորություն է տալիս ստանալ թարմ, ճշգրիտ և վերլուծության համար պատրաստ տեղեկատվություն երկրի մակերևույթի վրա տեղի ունեցող փոփոխությունների և գործընթացների վերաբերյալ։ Բարձր լուծաչափի տիեզերանկարների հիման վրա ստեղծված օրթոֆոտոները թույլ են տալիս հստակ նույնականացնել օբյեկտները, իրականացնել փոփոխությունների հայտնաբերում և գնահատում, ինչպես նաև ստանալ տարածքի ճշգրիտ ու արդիական քարտեզագրական պատկեր։\nԱյս տվյալները կիրառվում են ռելիեֆի բարձր ճշգրտության 3D մոդելների ստեղծման, տարածքային պլանավորման, ենթակառուցվածքների մոնիթորինգի և թվային տեսողական տեղորոշման համակարգերի զարգացման համար։ Արդյունքում՝ հեռազննումը դառնում է վստահելի հիմք արագ որոշումների կայացման, արդյունավետ կառավարման և ժամանակակից աշխարհատարածական լուծումների ներդրման համար։",
  image: {
    src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/aerospace_security_sector.png?v=5j1l8gx1f0j",
    srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/aerospace_security_sector.png?v=ey83g5nb6dn",
    sizes: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/aerospace_security_sector.png?v=1pkld6vhhsr",
    alt: "Բարձր լուծաչափով արբանյակային նկարներ"
  }
}, {
  id: 2,
  title: "Ուսումնական և Գիտահետազոտական Կենտրոններ",
  subtitle: "",
  description: "Հեռազննումը հնարավորություն է տալիս իրականացնել լայնածավալ տարածքային մոնիթորինգ, գյուղատնտեսական հողերի վերլուծություն, անտառային ռեսուրսների կառավարում և շրջակա միջավայրի ազդեցության գնահատում՝ հիմնվելով ճշգրիտ և արդիական տարածական տվյալների վրա։\nՏիեզերանկարները համատեղում են բարձր մանրամասնությունն ու մեծ տարածքային ընդգրկումը՝ ապահովելով ծախսարդյունավետ լուծումներ հատկապես լայն աշխարհագրական տարածքների կառավարման համար։ Դրանք թույլ են տալիս հայտնաբերել տարածքային փոփոխությունները, վերլուծել բնական և մարդածին գործընթացները, կանխատեսել հնարավոր ռիսկերը և ժամանակին իրականացնել կանխարգելիչ միջոցառումներ։",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/research_centers_sector.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/research_centers_sector.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/research_centers_sector.png",
    alt: "ARMSAT1 արբանյակային նկարներ"
  }
}, {
  id: 3,
  title: "Գյուղատնտեսություն\xA0",
  subtitle: "Ճշգրիտ հողագործություն և մոնիտորինգ",
  description: "Բազմասպեկտրալ և ռադիոլոկացիոն արբանյակային նկարահանման շնորհիվ հեռազննումը գյուղատնտեսության մեջ դառնում է արդյունավետ կառավարման հզոր գործիք։ Այն հնարավորություն է տալիս իրականացնել բերքի առողջության մոնիթորինգ՝ NDVI ինդեքսի միջոցով, գնահատել հողի խոնավությունը, օպտիմալացնել ոռոգման գործընթացները, վաղ փուլում հայտնաբերել հիվանդություններն ու վնասատուները, ինչպես նաև կանխատեսել բերքատվությունը։\nԱյս լուծումները հանդիսանում են խելացի գյուղատնտեսության կարևոր բաղադրիչ՝ օգնելով ֆերմերներին և ոլորտի կառույցներին կայացնել արագ, ճշգրիտ և տվյալների վրա հիմնված որոշումներ։ Ժամանակակից տեխնոլոգիաների կիրառմամբ հնարավոր է ապահովել առավելագույն բերքատվություն՝ նվազեցնելով ծախսերը, ռեսուրսների անարդյունավետ օգտագործումը և շրջակա միջավայրի վրա բացասական ազդեցությունը։",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/agriculture_monitoring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/agriculture_monitoring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/agriculture_monitoring.png-wvc-sizes",
    alt: "Գյուղատնտեսության մոնիտորինգ"
  }
}, {
  id: 4,
  title: "Հանքարդյունաբերություն\xA0",
  subtitle: "Արդյունավետ արդյունահանում",
  description: "Հեռազննումը հանքարդյունաբերության և երկրաբանական ուսումնասիրությունների ոլորտում ապահովում է ճշգրիտ, արագ և ծախսարդյունավետ տվյալներ՝ նպաստելով պաշարների արդյունավետ գնահատմանը, ռիսկերի նվազեցմանը և աշխատանքների անվտանգ կազմակերպմանը։\nԲազմասպեկտրալ և հիպերսպեկտրալ արբանյակային պատկերները հնարավորություն են տալիս իրականացնել լիթոլոգիական քարտեզագրում՝ տարբերակելով ապարների տեսակները դրանց սպեկտրալ արտացոլման առանձնահատկությունների հիման վրա։ Ստերեո-նկարահանումների միջոցով ստեղծվում են բացահանքերի բարձր ճշգրտության 3D մոդելներ, որոնք թույլ են տալիս հաշվարկել հանված հանքաքարի, լցակույտերի և տեղաշարժված զանգվածների ծավալները։\nՌադիոլոկացիոն բարձր ճշգրտության նկարահանումները կիրառվում են կառուցվածքային վերլուծության համար՝ հնարավորություն տալով հայտնաբերել խզվածքային գծեր, ճեղքեր, անկայուն գոտիներ և հավանական փլուզման ռիսկեր։ Արդյունքում՝ հեռազննումը դառնում է կարևոր գործիք հանքավայրերի կառավարման, երկրաբանական վերլուծության և անվտանգ շահագործման գործընթացներում։",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/mining_exploration.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/mining_exploration.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/mining_exploration.png",
    alt: "Քաղաքաշինություն և պլանավորում"
  }
}, {
  id: 5,
  title: "Շրջակա Միջավայր և Աղետների Կառավարում\xA0",
  subtitle: "Էկոհամակարգերի վերահսկում",
  description: "Հեռազննումը կարևոր դեր է խաղում արտակարգ իրավիճակների կառավարման և օպերատիվ արձագանքման գործընթացներում՝ ապահովելով արագ, ճշգրիտ և արդիական տեղեկատվություն աղետի գոտու վերաբերյալ։ Արբանյակային պատկերների միջոցով հնարավոր է կարճ ժամանակում գնահատել աղետի մասշտաբները, հայտնաբերել վնասված ենթակառուցվածքները, քանդված կամուրջները, փակված ճանապարհները և այլ կրիտիկական օբյեկտներ։\nՏիեզերանկարները հնարավորություն են տալիս արդյունավետորեն կոորդինացնել փրկարարական լոգիստիկան, պլանավորել անվտանգ մուտքի ուղիները և առաջնահերթություն տալ առավել տուժած տարածքներին։ Անտառային հրդեհների դեպքում հեռազննումը կիրառվում է հրդեհի օջախների տեղորոշման, տարածման ուղղության և ինտենսիվության գնահատման համար։",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/environmental_protection.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/environmental_protection.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/environmental_protection.png-wvc-sizes",
    alt: "Բնապահպանական մոնիտորինգ"
  }
}, {
  id: 6,
  title: "Էներգետիկա և Տելեկոմ",
  subtitle: "Ենթակառուցվածքների անվտանգություն",
  description: "Վերահսկեք էլեկտրահաղորդման գծերը, խողովակաշարերը և վերականգնվող էներգիայի կայանները: Կանխարգելեք վթարները և օպտիմալացրեք սպասարկման աշխատանքները տիեզերական տվյալների հիման վրա՝ ապահովելով անխափան էներգամատակարարում:",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/energy_infrastructure.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/energy_infrastructure.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/energy_infrastructure.png-wvc-sizes",
    alt: "Էներգետիկ ենթակառուցվածքներ"
  }
}, {
  id: 7,
  title: "Բանկեր, Ֆինանսներ, Ապահովագրություն",
  subtitle: "Արդյունավետ արդյունահանում",
  description: "Բարելավեք հանքավայրերի հետախուզումը և շահագործումը ճշգրիտ երկրաբանական քարտեզագրման միջոցով: Հետևեք բնապահպանական նորմերի պահպանմանը, վերահսկեք արդյունահանման ծավալները և նվազեցրեք գործառնական ռիսկերը:",
  image: {
    src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/7f1d85c1-e510-42b7-aa68-e8641f665f2e.jpg?v=eq76i6jh8eo",
    srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/7f1d85c1-e510-42b7-aa68-e8641f665f2e.jpg?v=204piyxm3mgj",
    sizes: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/7f1d85c1-e510-42b7-aa68-e8641f665f2e.jpg?v=c2ync3la0ev",
    alt: "Հանքարդյունաբերության մոնիտորինգ"
  }
}, {
  id: 8,
  title: "Լոգիստիկա",
  subtitle: "Երթուղիների օպտիմալացում",
  description: "Ստեղծեք և թարմացրեք ճանապարհային ցանցի թվային քարտեզները: Բարելավեք լոգիստիկ գործընթացները, ապահովեք տրանսպորտային միջոցների անվտանգ տեղաշարժը և օպտիմալացրեք մատակարարման շղթաները արբանյակային տվյալների օգնությամբ:",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/logistics_sector.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/logistics_sector.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/logistics_sector.png",
    alt: "Տրանսպորտ և լոգիստիկա"
  }
}, {
  id: 9,
  title: "Ժուռնալիստիկա\xA0",
  subtitle: "Տարածքների ճշգրիտ գնահատում",
  description: "Իրականացրեք հողամասերի ճշգրիտ չափագրում և գնահատում նախքան ներդրումներ կատարելը: Օգտագործեք 3D մոդելներ և բարձր լուծաչափով պատկերներ՝ ապագա կառույցների տեսողական ներկայացման և շրջակա միջավայրի հետ համատեղելիության վերլուծության համար:",
  image: {
    src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/image242.png?v=yla79f3xn8b",
    srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/image242.png?v=drcaijgis7u",
    sizes: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/image242.png?v=prx9nogbfr",
    alt: "Անշարժ գույքի զարգացում"
  }
}];
function IndustryRow({
  item,
  index
}: {
  item: (typeof industries)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const isEven = index % 2 === 0;
  return <div ref={ref} className={`flex flex-col lg:flex-row gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"} ${isEven ? "" : "lg:flex-row-reverse"}`}>
      <div id={{
      1: "aerospace",
      2: "research",
      3: "agriculture",
      4: "mining",
      5: "environment",
      6: "energy",
      7: "finance",
      8: "logistics",
      9: "journalism"
    }[item.id]} className="flex-1 space-y-6 w-full">
        <h3 // id={{
      // 1: "aerospace",
      //2: "research",
      //3: "agriculture",
      //  4: "mining",
      // 5: "environment",
      //6: "energy",
      // 7: "finance",
      // 8: "logistics",
      //9: "journalism"
      // }[item.id]} 
      className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground leading-tight">
          {item.title}
        </h3>
        {item.subtitle}
        <p className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed">
          {item.description}
        </p>
      </div>
      <div className="flex-1 w-full">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-primary/20 border border-border/30 group">
          <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none"></div>
          <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        </div>
      </div>
    </div>;
}
export default function IndustrySolutionsZLayout() {
  // 1. Create a map matching the industry item IDs to your navigation hash links
  const sectionIds: Record<number, string> = {
    1: "aerospace",
    2: "research",
    3: "agriculture",
    4: "mining",
    5: "environment",
    6: "energy",
    7: "finance",
    8: "logistics",
    9: "journalism"
  };
  return <section id="industrysolutionszlayout" className="bg-background text-foreground overflow-hidden light">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col">
          {industries.map((item, index) => <div key={item.id} data-index={index}>
              <div id={{
            1: "aerospace",
            2: "research",
            3: "agriculture",
            4: "mining",
            5: "environment",
            6: "energy",
            7: "finance",
            8: "logistics",
            9: "journalism"
          }[item.id]} className="py-16 md:py-24 lg:py-32">
                <IndustryRow item={item} index={index} />
              </div>
              {index < industries.length - 1 && <Separator className="bg-border/20" />}
            </div>)}
        </div>
      </div>
    </section>;
}